module.exports = __webpack_public_path__ + "media/images/emblems/Safiental-a965821b702d614ebea158379b652eac.svg";